import { IInputItems } from '@/typings';

export const indicadorAcidente: IInputItems[] = [
  { label: '0 - Trabalho', value: '0' },
  { label: '1 - Trânsito', value: '1' },
  { label: '2 - Outros', value: '2' },
  { label: '9 - Não acidente', value: '9' },
];
